'use client';

import { Alert, Link } from '@coolblue-development/freddy';
import selectRemoveAllFiltersTrigger from '@coolblue-development/ga4-events/triggers/RecruitmentFilterResults/selectRemoveAllFiltersTrigger';
import showNoResultsBannerTrigger from '@coolblue-development/ga4-events/triggers/RecruitmentFilterResults/showNoResultsBannerTrigger';
import { ArrowRight } from '@coolblue-development/icons';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { useTranslation } from '@i18n/useTranslation';
import { useEffect } from 'react';

import { useFiltersContext } from '../Context/useFiltersContext';

export const NoFilterResult = () => {
  const { t } = useTranslation('filterPage.noResult');
  const { clearFilters } = useFiltersContext();
  const { trackEvent } = useAnalytics();

  useEffect(() => {
    trackEvent(showNoResultsBannerTrigger());
  }, [trackEvent]);

  return (
    <Alert
      hideIcon
      description={t('description')}
      action={
        <Link
          component='button'
          startIcon={<ArrowRight />}
          onClick={() => {
            trackEvent(selectRemoveAllFiltersTrigger());
            clearFilters();
          }}
        >
          {t('link')}
        </Link>
      }
    />
  );
};
